import React from 'react';

interface ProjectTimelineInfoProps {
  form: any;
  updateForm: (data: any) => void;
}

export function ProjectTimelineInfo({ form, updateForm }: ProjectTimelineInfoProps) {
  return (
    <section className="rounded-md bg-white p-4  border border-slate-100 space-y-4">
      <h3 className="text-sm font-normal text-slate-900 tracking-wider">Thông tin thời gian</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Ngày khởi công */}
        <div className="space-y-1.5">
          <label className="text-xs lg:text-sm font-normal text-slate-700">Ngày khởi công dự kiến <span className="text-rose-500">*</span></label>
          <div className="relative">
            <input 
              type="date"
              value={form.startDate || ''}
              onChange={e => updateForm({ startDate: e.target.value })}
              className="h-10 w-full rounded-md border border-slate-200 px-3 pr-10 text-xs lg:text-sm font-normal text-slate-700 outline-none focus:border-emerald-500"
            />
            <i className="ri-calendar-line absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
          </div>
        </div>

        {/* Ngày hoàn thành */}
        <div className="space-y-1.5">
          <label className="text-xs lg:text-sm font-normal text-slate-700">Ngày hoàn thành dự kiến <span className="text-rose-500">*</span></label>
          <div className="relative">
            <input 
              type="date"
              value={form.endDate || ''}
              onChange={e => updateForm({ endDate: e.target.value })}
              className="h-10 w-full rounded-md border border-slate-200 px-3 pr-10 text-xs lg:text-sm font-normal text-slate-700 outline-none focus:border-emerald-500"
            />
            <i className="ri-calendar-line absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
          </div>
        </div>

        {/* Thời gian thực hiện */}
        <div className="space-y-1.5">
          <label className="text-xs lg:text-sm font-normal text-slate-700">Thời gian thực hiện (tháng)</label>
          <div className="flex items-center rounded-md border border-slate-200 overflow-hidden focus-within:border-emerald-500 transition-all">
            <input 
              type="number"
              value={form.duration || ''}
              onChange={e => updateForm({ duration: e.target.value })}
              placeholder="Nhập số tháng"
              className="h-10 flex-1 px-3 text-xs lg:text-sm font-normal text-slate-700 outline-none"
            />
            <span className="px-3 text-xs lg:text-sm font-normal text-slate-400 border-l border-slate-100 bg-slate-50/50">tháng</span>
          </div>
        </div>
      </div>
    </section>
  );
}
